const setLeftFloorplanId = (state, floorplanId) => {
  state.leftFloorplanId = floorplanId;
};

const setRightFloorplanId = (state, floorplanId) => {
  state.rightFloorplanId = floorplanId;
};

export default {
  setLeftFloorplanId,
  setRightFloorplanId
};



// WEBPACK FOOTER //
// ./src/store/modules/floorplans/compare/mutations.js